import React, { useState } from 'react';
import ThoughtLeadershipTab from './ThoughtLeadershipTab';
import ThoughtLeadershipForYou from './ThoughtLeadershipForYou';
import ExpertiseTab from './ExpertiseTab';

/**
 * Content Studio: the thought-leadership studio (BD-18), what a colleague's pieces suggest I send (BD-18), and the
 * expertise library they draw on (BD-17).
 */

type Section = 'studio' | 'for_you' | 'library';
const SECTIONS: { value: Section; label: string }[] = [
  { value: 'studio', label: 'Thought leadership' },
  { value: 'for_you', label: 'For you to send' },
  { value: 'library', label: 'Expertise library' },
];

const ContentStudioTab: React.FC = () => {
  const [section, setSection] = useState<Section>('studio');
  return (
    <div className="space-y-4">
      <div className="flex gap-2" role="tablist" aria-label="Content Studio">
        {SECTIONS.map((s) => (
          <button
            key={s.value}
            type="button"
            role="tab"
            aria-selected={section === s.value}
            onClick={() => setSection(s.value)}
            className={`px-3 py-1.5 text-sm rounded-full border ${section === s.value ? 'bg-blue-50 border-blue-300 text-blue-700' : 'border-gray-200 text-gray-600'}`}
          >
            {s.label}
          </button>
        ))}
      </div>
      {section === 'studio' && <ThoughtLeadershipTab />}
      {section === 'for_you' && <ThoughtLeadershipForYou />}
      {section === 'library' && <ExpertiseTab />}
    </div>
  );
};

export default ContentStudioTab;
